import { useContext } from 'react';
import { DiagnosticoContext } from './DiagnosticoContext';

export const useDiagnostico = () => useContext(DiagnosticoContext);
